import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
const useStyles = makeStyles(theme => {
  const { left, right } = theme.mixins;
  return {
    root: {
      backgroundColor: theme.palette.background.default,
      ...theme.shape.fullBleedingBox,

      '&.explore-hotels .main-heading': {
        ...theme.typography.h4,
        ...theme.mixins.marginLeft(0),
      },

      '& .Type3': {
        background: 'transparent !important',
        marginBottom: '0 !important',
        '& .slick-track': {
          ...theme.mixins.left(`0 !important`),
        },
      },
      '&.ourRecommendation , &.explore-hotels': {
        ...theme.shape.componentSpacing,
        backgroundColor: ({ params }) =>
          (params && params.backgroundColor) || theme.palette.background.default,
        '& .main-heading': {
          color: ({ params }) => (params && params.textColor) || theme.palette.text.primary,
        },
        '& .infographicsbgImage-moreLikethis': {
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          position: 'absolute',
          bottom: 0,
          ...right(0),
          ...left('auto'),
          height: '100%',
          width: '70%',
          transform: `scale(${theme.isDirectionRTL ? '-' : ''}1, 1)`,
          backgroundImage: ({ fields }) =>
            (fields && fields.supergraphicImage && fields.supergraphicImage.value && `url(${fields.supergraphicImage.value.src})`),
          [theme.breakpoints.down('md')]: {
            backgroundImage: ({ fields }) =>
              (fields && fields.supergraphicImage && fields.supergraphicImage.value && `url(${fields.supergraphicImage.value.src})`),
            width: '67%',
          },
        },
        '& .Type3': {
          backgroundColor: 'transparent',
          marginBottom: 0,
          '&.no-cta': {
            '& .slick-prev, & .slick-next': {
              top: '50%',
              transform: 'translateY(-50%)',
            },
          },
          '& .slick-prev, & .slick-next': {
            top: '50%',
            transform: 'translateY(-50%)',
          },
          '& .slick-prev': {
            left: pxToRem(-20),
            right: 'auto',
          },
          '& .slick-next': {
            left: 'auto',
            right: pxToRem(-20),
          },
          '& .slick-prev > button, & .slick-next > button': {
            borderWidth: ({ params }) =>
              params && params.backgroundColor ? 0 : 1,
            backgroundColor: ({ params }) =>
              params && params.backgroundColor ? theme.mixins.White() : theme.mixins.White(0),
            '& svg': {
              color: ({ params }) =>
                params && params.backgroundColor ? theme.mixins.RussianViolet() : theme.mixins.Black(),
            },
            '&:hover': {
              backgroundColor: ({ params }) =>
                params && params.backgroundColor ? theme.mixins.RussianViolet() : theme.mixins.Black(300),
              '& svg': {
                color: ({ params }) =>
                  params && params.backgroundColor ? theme.mixins.White() : theme.mixins.Black(),
              },
            },
          },
        },
      },
    },
  }
});

export default useStyles;
